import { IAvidaZendeskToken } from "libs/models/Engagements";
import { IEngagementsCustomerResponse } from "../../../../models/Customer/EngagementsCustomer";

export const mockCustomerData: IEngagementsCustomerResponse = {
  customer: {
    customerId: "24325123",
    name: "Test",
    surName: "Testsson",
    address: {
      addressLine1: "Testvägen 1",
      addressLine2: "",
      city: "STOCKHOLM",
      country: "SWEDEN",
      zipCode: "12648",
    },
    email: "test@santanderconsumer.se",
    mobile: "+46700000000",
    phone: "46700000000",
    isPartnerCustomer: false,
    parties: [],
  },
};

export const mockZendeskTokenData: IAvidaZendeskToken = {
  token: "token",
};
